"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var angular = require("angular");
require('../craft-experiment/craft-experiment.component.css');
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var ISSUE_TYPE_COLOR = {
    Discovery: "#FFEAF4",
    Specify: "#FFFFB7",
    Navigate: "#C6DCFB",
    Manage: "#CFFFEE"
};
function discoveryGrid(ignorance, impact) {
    return ignorance >= 5 && impact >= 5
        ? "Discovery"
        : ignorance >= 5 && impact < 5
            ? "Specify"
            : ignorance < 5 && impact >= 5
                ? "Navigate"
                : "Manage";
}
var CraftExperimentComponent = /** @class */ (function () {
    function CraftExperimentComponent($rootScope, $scope, $timeout) {
        this.issueConfig = {};
        this.initLearningPlanSection = 4;
        this.disableEdit = false;
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.$rootScope = $rootScope;
        ctrl.dashboardExpPriority = false;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DFV);
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.showGenerateBtn = false;
        ctrl.guideCommand = '';
        ctrl.stopLoadingSpinner = function () {
            $scope.$emit('workbench:loading', { 'load': false });
        };
        $scope.$on('command:CRAFT_EXPERIMENT', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.guideCommand = '';
            ctrl.initLearningPlanSection = args.initLearningPlanSection;
            ctrl.isDataLoaded = false;
            ctrl.getNColCanvasConfig();
            ctrl.initComponent(event, args);
            ctrl.clearDivs();
        });
        $timeout();
        $('select option')
            .filter(function () {
            return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
        })
            .remove();
    }
    CraftExperimentComponent.prototype.getNColCanvasConfig = function () {
        var ctrl = this;
        var config = ctrl.utilsService.getIssueConfigFromStorage(true);
        ctrl.issueConfig = config.issueConfig;
        ctrl.display = config.title;
    };
    CraftExperimentComponent.prototype.setGlobalDirty = function () {
        var ctrl = this;
        ctrl.$timeout(function () {
            ctrl.$rootScope.smartorgDirty = ctrl.isDirty;
        }, 0);
    };
    CraftExperimentComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem ? args.actionMenuItem : "Experiments";
        // Handsonetable Setting
        ctrl.settings = {
            colHeaders: true,
            stretchH: "all",
            colWidths: ["25vw", "15vw", "15vw", "25vw", "15vw", "15vw"],
            // height: "60vh",
            width: "70vw",
            licenseKey: "ee979-f3485-d8862-46b42-8ee23",
            cells: function (row, col) {
                var cellPrp = {};
                cellPrp.className = (col == 0) ? 'htLeft htMiddle cursor-pointer' : 'htCenter htMiddle';
                if (col === 1) {
                    cellPrp.renderer = ctrl.IssueTypeRenderer;
                }
                if (col === 4) {
                    cellPrp.renderer = ctrl.myRenderer;
                }
                return cellPrp;
            },
            // afterDropdownMenuShow(instance) {
            //     var filters = instance.hot.getPlugin('filters');
            //         console.log(filters.valueComponent)
            //       filters.components.get('filter_by_value').elements[0].onClearAllClick({preventDefault: function() {}});
            // },
            afterOnCellMouseDown: function (event, coords) {
                var indexGotHere = this.toPhysicalRow(coords.row);
                // let indexGotHere= coords.row;
                if (coords.col == 0) {
                    ctrl.selectIssue(indexGotHere);
                    // alert(ctrl.issueData.length)
                }
                ctrl.$scope.$apply();
            },
            afterGetColHeader: function (col, TH) {
                if (col === 2 || col === 4) {
                    var button = TH.querySelector(".changeType");
                    if (!button) {
                        return;
                    }
                    button.parentElement.removeChild(button);
                }
            },
            afterColumnSort: function (currentSortCfg, destSortCfg) {
                // alert(ctrl.issueData.length)
            },
            viewportColumnRenderingOffset: 70,
            columnSorting: {
                initialConfig: {
                    column: 2,
                    sortOrder: 'desc'
                }
            }
        };
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.isQualitative = false;
        if ('inavImpactType' in ctrl.node) {
            ctrl.isQualitative = ctrl.node['inavImpactType'] == 'Qualitative';
        }
        ctrl.fteGlobal = args.fte;
        ctrl.tornadoFactors = args.factors;
        ctrl.tornadoFactors.forEach(function (f) {
            f['Comment'] = decodeURIComponent(f['Comment']);
        });
        ctrl.tornadoFactors = ctrl.tornadoFactors.concat([
            { 'Factor': 'Chance of Failure - High (75% to 100%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Middle (Around 50%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Low (Less than 25%)', 'Comment': '' }
        ]);
        ctrl.origTornadoFactors = angular.copy(ctrl.tornadoFactors);
        ctrl.origStatus = ["Completed", "In Plan", "Backlog", "Unplanned", "Active"];
        ctrl.node = args.node;
        ctrl.issueData = [];
        ctrl.selectedIssue = null;
        ctrl.isDirty = false;
        ctrl.getIssueDetailsFromDb();
        ctrl.menu = [];
        ctrl.setGlobalDirty();
    };
    CraftExperimentComponent.prototype.showTable = function (issueData) {
        var ctrl = this;
        ctrl.clearDivs();
        ctrl.loadHotTableConfig();
        ctrl.isDataLoaded = true;
        var expTable = document.getElementById('exp-table');
        var hotExp = new Handsontable(expTable, __assign(__assign({}, ctrl.settings), { colHeaders: ctrl.colHeaders, columns: ctrl.columns, data: ctrl.issueData }));
    };
    CraftExperimentComponent.prototype.loadHotTableConfig = function () {
        var ctrl = this;
        ctrl.dropdownMenu = [
            "filter_by_value",
            "filter_action_bar",
            "filter_by_condition",
        ];
        ctrl.colHeaders = [
            "Issue",
            "Issue Type",
            "Surprise Index",
            "Experiment",
            "Defined",
            "Status"
        ];
        ctrl.colWidths = ["25vw", "15vw", "15vw", "25vw", "15vw", "15vw"];
        // height: "60vh",
        // width: "70vw",
        ctrl.columns = [
            { data: "name", className: "htLeft htMiddle cursor-pointer", readOnly: true },
            { data: "issueType", className: "htCenter htMiddle", readOnly: true },
            { data: "score", className: "htCenter htMiddle", readOnly: true },
            { data: "expName", className: "htCenter htMiddle", readOnly: true },
            { data: "defined", className: "htCenter htMiddle", readOnly: true },
            { data: "status", className: "htCenter htMiddle", readOnly: true },
        ];
    };
    CraftExperimentComponent.prototype.clearDivs = function () {
        try {
            document.getElementById('issues-handson').innerHTML = "";
        }
        catch (e) {
        }
    };
    CraftExperimentComponent.prototype.IssueTypeRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = this;
        // let discoveryQuadrant = {
        //     Discovery: "#FFEAF4",
        //     Specify: "#FFFFB7",
        //     Navigate: "#C6DCFB",
        //     Manage: "#CFFFEE",
        // };
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        if (value) {
            td.style.backgroundColor = ISSUE_TYPE_COLOR[value.replace(/ /g, "")];
        }
        // console.log(value, discoveryQuadrant[value.replace(/ /g, "")]);
    };
    CraftExperimentComponent.prototype.myRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.innerHTML = '';
        var divMain = document.createElement('DIV');
        divMain.className = 'process-back';
        var valuePara = document.createElement('p');
        valuePara.className = 'process-value';
        valuePara.innerHTML = value + " %";
        var div = document.createElement('DIV');
        div.className = 'process';
        div.style.width = value + '%';
        divMain.appendChild(valuePara);
        divMain.appendChild(div);
        td.appendChild(divMain);
    };
    CraftExperimentComponent.prototype.discoveryGrid = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "Discovery"
            : ignorance >= 5 && impact < 5
                ? "Specify"
                : ignorance < 5 && impact >= 5
                    ? "Navigate"
                    : "Manage";
    };
    CraftExperimentComponent.prototype.selectFactor = function () {
        var ctrl = this;
        ctrl.currExperiment.issueFactor = ctrl.selectedFactor;
        ctrl.checkSave();
    };
    CraftExperimentComponent.prototype.selectStatus = function () {
        var ctrl = this;
        ctrl.currExperiment.status = ctrl.selectedStatus;
        ctrl.checkSave();
    };
    CraftExperimentComponent.prototype.getIssueDetailsFromDb = function () {
        var ctrl = this;
        ctrl.smartorg.getInavIssueAndExperiment(ctrl.node['_id']).then(function (res) {
            if (res.status == 1) {
                ctrl.stopLoadingSpinner();
                ctrl.showAlert('danger', 'Error!', res.message);
            }
            else {
                var filteredData = ctrl.utilsService.filterZeroImpactIgnorance(res, ctrl.isQualitative);
                ctrl.issueData = filteredData.map(function (item) { return ctrl.utilsService.formatIssueData(item, ctrl.isQualitative, ctrl.fteGlobal); });
                ctrl.issueData.sort(function (a, b) { return (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0); });
                ctrl.showGenerateBtn = true;
                ctrl.menu = [];
                ctrl.stopLoadingSpinner();
                ctrl.showTable(ctrl.issueData);
                // ctrl.$scope.$apply();
            }
        })["catch"](function (err) {
            ctrl.stopLoadingSpinner();
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    CraftExperimentComponent.prototype.initSelectFactors = function () {
        var ctrl = this;
        if (ctrl.currExperiment.issueFactor) {
            if (ctrl.currExperiment.impactMappingList && ctrl.currExperiment.impactMappingList != "default") {
                var selectedFactorIndex = ctrl.currExperiment.impactMappingList.findIndex(function (f) { return (ctrl.currExperiment.issueFactor.key === f.key); });
                ctrl.selectedFactor = ctrl.currExperiment.impactMappingList[selectedFactorIndex];
            }
        }
        else {
            ctrl.selectedFactor = undefined;
        }
    };
    CraftExperimentComponent.prototype.initSelectStatus = function () {
        var ctrl = this;
        if (ctrl.currExperiment.status) {
            var selectedStatusIndex = ctrl.origStatus.findIndex(function (f) { return (ctrl.currExperiment.status === f); });
            ctrl.selectedStatus = ctrl.origStatus[selectedStatusIndex];
        }
        else {
            ctrl.selectedStatus = undefined;
        }
    };
    CraftExperimentComponent.prototype.clearSelection = function () {
        var ctrl = this;
        ctrl.selectedIssue = null;
        ctrl.isDirty = false;
    };
    CraftExperimentComponent.prototype.selectIssue = function (index) {
        var ctrl = this;
        ctrl.selectedIndex = index;
        ctrl.selectedIssue = angular.copy(ctrl.issueData[index]);
        $("#experimentInput").focus();
        ctrl.currExperiment = ctrl.utilsService.getIssueDetails(ctrl.selectedIssue, ctrl.fteGlobal);
        ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
        ctrl.initSelectFactors();
        ctrl.initSelectStatus();
        ctrl.expSelected = true;
        ctrl.$scope.$apply();
    };
    CraftExperimentComponent.prototype.updateCurrExp = function () {
        var ctrl = this;
        ctrl.expSelected = true;
        ctrl.checkSave();
    };
    CraftExperimentComponent.prototype.updateIterPlanInIssueData = function () {
        var ctrl = this;
        var updatedIssueData = angular.copy(ctrl.issueData);
    };
    CraftExperimentComponent.prototype.resetBack = function () {
        var ctrl = this;
        ctrl.currExperiment = angular.copy(ctrl.origCurrExperiment);
        // ctrl.checkSave();
        ctrl.clearSelection();
    };
    CraftExperimentComponent.prototype.saveCurrentExp = function () {
        var ctrl = this;
        ctrl.currExperiment['initLearningPlanSection'] = ctrl.initLearningPlanSection;
        ctrl.updatedIssueData = ctrl.utilsService.updateIssueData(ctrl.issueData, ctrl.selectedIndex, ctrl.currExperiment, ctrl.fteGlobal);
        ctrl.issueData = angular.copy(ctrl.updatedIssueData);
        ctrl.saveExperimentData();
    };
    CraftExperimentComponent.prototype.saveExperimentData = function () {
        var ctrl = this;
        var issueToBeSaved = angular.copy(ctrl.issueData[ctrl.selectedIndex]);
        var experimentToBeSaved = angular.copy(issueToBeSaved['experimentData'][0]);
        if (experimentToBeSaved['_id'] == '') {
            delete experimentToBeSaved['_id'];
        }
        this.smartorg.saveInavExperimentData(issueToBeSaved['_id'], experimentToBeSaved).then(function (res) {
            if (res.status == 0) {
                ctrl.isDirty = false;
                ctrl.setGlobalDirty();
                ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
                ctrl.showAlert('success', 'Saved!', 'Details saved for issue "' +
                    ctrl.issueData[ctrl.selectedIndex]['name'] + '"');
                ctrl.clearSelection();
                ctrl.isDataLoaded = false;
                ctrl.getIssueDetailsFromDb();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    CraftExperimentComponent.prototype.onFteChange = function () {
        var ctrl = this;
        ctrl.utilsService.onFteChange(ctrl.currExperiment, ctrl.fteGlobal, function () { ctrl.checkSave(); });
    };
    CraftExperimentComponent.prototype.checkSave = function () {
        var ctrl = this;
        ctrl.isDirty = this.utilsService.checkSave(ctrl.currExperiment, ctrl.origCurrExperiment);
        ctrl.setGlobalDirty();
    };
    return CraftExperimentComponent;
}());
angular.module('smartorg.r6.acts.craftExperiment', []).component('craftExperiment', {
    template: require('./craft-experiment.component.html'),
    controller: CraftExperimentComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.craftExperiment';
//# sourceMappingURL=craft-experiment.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/craft-experiment/craft-experiment.component.js